/**
 * @class
 * @classdesc A wrapper around Map with utility methods for config access.
 */
export class ConfigMap {
  /**
   * @param {Object|Array<[string, string]>} initialEntries
   */
  constructor(initialEntries = []) {
    let entries = [];

    // If it's already an array of entries, use it directly
    if (Array.isArray(initialEntries)) {
      entries = initialEntries;
    }
    // If it's a plain object, convert it to [key, value] pairs
    else if (initialEntries && typeof initialEntries === "object") {
      entries = Object.entries(initialEntries);
    }

    // Internal map instance
    this._map = new Map(entries);
  }

  /**
   * @param {string} key
   * @param {*} defaultValue
   * @returns {*}
   */
  getValue(key, defaultValue) {
    return this._map.get(key) ?? defaultValue;
  }

  /**
   * @param {string} key
   * @param {boolean} defaultValue
   * @returns {boolean}
   */
  isEnabled(key, defaultValue) {
    if (this._map.has(key)) {
      return (
        String(this._map.get(key)) === "true" ||
        String(this._map.get(key)) === "1"
      );
    } else {
      return String(defaultValue) === "true" || String(defaultValue) === "1";
    }
  }

  /** @returns {Map<string, string>} */
  getMap() {
    return this._map;
  }
}
